import { ClientsPage } from '../pages/clients'
import { ClientPage } from '../pages/client'
import { CreateClientModal } from '../pages/create'
import { EditClientProfileModal } from '../pages/edit-client-profile'
import { EditClientDetailsModal } from '../pages/edit-client-details'
import { CreateClientAppointmentModal } from '../pages/create-appointment'
import { DetailsTab } from '../pages/client/details'
import { Navigate } from 'react-router'
import { RouteObject } from 'react-router'
import { PetsTab } from '../pages/client/pets'
import { AppointmentHistoryTab } from '../pages/client/appointment-history'
import { CreateClientPetModal } from '../pages/create-pet'

export enum ClientRoutePath {
  Clients = '/clients',
  ClientsView = '/clients/:id',
  ClientsCreate = 'create',
  ClientsCreateAppointment = 'create-appointment',
  ClientsDetails = 'details',
  ClientsAppointmentHistory = 'appointments',
  ClientsPets = 'pets',
  ClientsPetsCreate = 'create-pet',
  ClientsProfileEdit = 'edit-profile',
  ClientsDetailsEdit = 'edit-details',
}

const createPetRoute = {
  path: ClientRoutePath.ClientsPetsCreate,
  element: <CreateClientPetModal />,
}

const createAppointmentRoute = {
  path: ClientRoutePath.ClientsCreateAppointment,
  element: <CreateClientAppointmentModal />,
}

export const protectedClientRoutes: RouteObject[] = [
  {
    path: ClientRoutePath.Clients,
    element: <ClientsPage />,
    children: [
      {
        path: ClientRoutePath.ClientsCreate,
        element: <CreateClientModal />,
      },
    ],
  },
  {
    path: ClientRoutePath.ClientsView,
    element: <ClientPage />,
    children: [
      {
        index: true,
        element: <Navigate
          to={ClientRoutePath.ClientsDetails}
          replace
        />,
      },
      {
        path: ClientRoutePath.ClientsDetails,
        element: <DetailsTab />,
        children: [
          {
            path: ClientRoutePath.ClientsProfileEdit,
            element: <EditClientProfileModal />,
          },
          {
            path: ClientRoutePath.ClientsDetailsEdit,
            element: <EditClientDetailsModal />,
          },
          createPetRoute,
          createAppointmentRoute,
        ],
      },
      {
        path: ClientRoutePath.ClientsPets,
        element: <PetsTab />,
        children: [
          {
            path: ClientRoutePath.ClientsProfileEdit,
            element: <EditClientProfileModal />,
          },
          createPetRoute,
          createAppointmentRoute,
        ],
      },
      {
        path: ClientRoutePath.ClientsAppointmentHistory,
        element: <AppointmentHistoryTab />,
        children: [
          {
            path: ClientRoutePath.ClientsProfileEdit,
            element: <EditClientProfileModal />,
          },
          createPetRoute,
          createAppointmentRoute,
        ],
      },
    ],
  },
]
